const selectForms = state => state.data.forms

const FormDataStoreSelectors = {
  forms: selectForms
}

export default FormDataStoreSelectors
